import { Amplify } from 'aws-amplify';

const getRedirectUrls = () => {
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    return { signIn: [origin], signOut: [origin] };
  }
  return {
    signIn: [process.env.REACT_APP_REDIRECT_SIGN_IN || ''],
    signOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT || ''],
  };
};

export const configureAmplify = () => {
  const { signIn: redirectSignIn, signOut: redirectSignOut } = getRedirectUrls();

  // Configure Amplify with the proper settings for federated sign-in
  // Using a type assertion to avoid TypeScript errors with the Amplify configuration
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
        userPoolClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || '',
        loginWith: {
          oauth: {
            domain: `${process.env.REACT_APP_COGNITO_DOMAIN}`,
            scopes: ['email', 'profile', 'openid'],
            redirectSignIn,
            redirectSignOut,
            responseType: 'code', // must be 'code' for Authorization Code Flow
          }
        }
      }
    }
  } as any); // Type assertion to avoid TypeScript errors
};
